import { combineReducers } from 'redux';
import gettocken from './getTokenReducer';
import getuserdata from './userReducer';
import getroles from './rolesReducer'


const rootReducers = combineReducers({
  gettocken: gettocken,
  getuserdata: getuserdata,
  getroles: getroles
});

export default rootReducers;